<template>
  <div :class="$style.news_page">
    <!-- todo: パンくず(phase2) -->
    <div :class="$style.heading_area">
      <MoleculesConsumerHeading :class="$style.heading" title="News" sub-title="ニュース一覧" align="left" />
    </div>
    <NewsList :class="$style.news_list" :news="newsItems" />
    <MoleculesConsumerPager :class="$style.pager" :total-page="totalPageCount" />
  </div>
</template>

<script setup lang="ts">
import { usePublicNewsSearchQuery } from "~/gql/urql.generated"
import { NewsFragment } from "~/types/type.generated"
import { createItemListJsonLD, createNewsJsonLD, useCustomMeta } from "~/composables/meta"
import { useToast } from "~/state"

const route = useRoute()
const customMeta = useCustomMeta()
const toast = useToast()

const perPage = 14
const page = computed(() => {
  return typeof route.query.page === "string" ? +route.query.page : 1
})

const variables = computed(() => {
  return {
    page: page.value,
    limit: perPage,
    sort: { release_date: -1, updated_unixtime: -1 },
  }
})
const { data: resNewsSearchQuery, error: newsSearchError, executeQuery } = await usePublicNewsSearchQuery({ variables })

const newsItems: ComputedRef<NewsFragment[]> = computed(() => {
  if (!resNewsSearchQuery?.value?.publicNewsSearch?.items) return []
  return resNewsSearchQuery.value.publicNewsSearch.items
})

const totalPageCount = computed(() => {
  return resNewsSearchQuery?.value?.publicNewsSearch?.pageInfo?.pageCount || 1
})

watch(
  () => route.fullPath,
  async () => {
    await executeQuery({ requestPolicy: "network-only" })
  },
)

watch(
  () => newsSearchError.value,
  (value) => {
    if (!value) return
    toast?.showErrorToasted(value.message)
  },
)

useHead(
  customMeta.fetch({
    title: "ニュースページ",
    description:
      "TENTIAL NEWSページは、TENTIALの最新情報やキャンペーン情報など、あなたのポテンシャルを引き出すために役立つ情報をお届けします",
    jsonLDInfo: createItemListJsonLD({
      count: newsItems.value?.length,
      items: newsItems.value?.map((news) => {
        return createNewsJsonLD({
          headline: news.title,
          image: news.thumbnail_image,
          description: news.description,
        })
      }),
    }),
  }),
)
</script>

<style scoped module lang="scss">
.news_page {
  @include container-lg;
  padding: 11px 0 5rem;
  .heading_area {
    padding: 0 1.25rem;
    @include md {
      padding: 0 2.25rem;
    }
  }
  .news_list {
    padding: 0 1.25rem;
    margin-bottom: 50px;
    @include md {
      padding: 0 2.25rem;
      margin-bottom: 40px;
    }
  }
  .pager {
    padding: 0 1.25rem;
    justify-content: flex-end;
    @include md {
      padding: 0 2.25rem;
    }
  }
}
</style>
